export default __webpack_public_path__ + "static/media/Level1.e40631b8.svg";